import { Shield } from 'lucide-react';

/**
 * Features grid + optional trusted-by social-proof badge on the landing page.
 */
export const LandingFeatures = ({ t, language, features, publicStats }) => (
  <section className="py-24 border-t border-border" data-testid="landing-features">
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
      <div className="text-center mb-16">
        <h2 className="text-3xl sm:text-4xl font-black tracking-tight mb-4">{t('landing.whyParentsLove')}</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">{t('landing.whyParentsDesc')}</p>
        {publicStats && (publicStats.teachers > 0 || publicStats.parents > 0) && (
          <div
            className="inline-flex items-center gap-2 px-4 py-2 mt-6 rounded-full border border-primary/30 bg-primary/10 text-sm"
            data-testid="trusted-by-badge"
          >
            <Shield className="w-4 h-4 text-primary shrink-0" />
            <span>
              {language === 'de' ? (
                <>
                  Vertraut von <strong className="text-primary">{publicStats.teachers}</strong> Lehrern und{' '}
                  <strong className="text-primary">{publicStats.parents}</strong> Eltern seit {publicStats.since_year}
                </>
              ) : (
                <>
                  Trusted by <strong className="text-primary">{publicStats.teachers}</strong> teachers and{' '}
                  <strong className="text-primary">{publicStats.parents}</strong> parents since {publicStats.since_year}
                </>
              )}
            </span>
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {features.map((feature) => {
          const FeatureIcon = feature.icon;
          return (
            <div key={feature.title} className="group p-8 bg-card border border-border rounded-sm card-hover">
              <div className="w-12 h-12 bg-primary/10 rounded-sm flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-200">
                <FeatureIcon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
              <p className="text-muted-foreground">{feature.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
